import { createRouter, createWebHistory } from 'vue-router'
import Home from "@/views/Home.vue";
import AnalysisManager from "@/views/AnalysisManager.vue";
import AnalysisOverview from "@/views/AnalysisOverview.vue";
import Teaser from "@/views/Teaser.vue";
import Lite from "@/views/Lite.vue";
import Full from "@/views/Full.vue";
import SupplierDetail from "@/views/SupplierDetail.vue";
import NotFound from "@/views/NotFound.vue";
import Suppliers from "@/views/Suppliers.vue";
import Network from "@/views/Network.vue";
import Tenders from "@/views/Tenders.vue";
import Contracts from "@/views/Contracts.vue";
import TenderDetail from "@/views/TenderDetail.vue";
import ContractDetail from "@/views/ContractDetail.vue";
import { CONFIG } from "@/config.js";


const routes = [
    {
        path: "/",
        name: "home",
        component: Home
    },
    {
        path: '/login',
        beforeEnter() {
            window.location = CONFIG.apiBaseUrl + "admin/login/?next=" + encodeURIComponent(window.location.href)
        },
        name: "login"
    },
    {
        path: "/tohle_je_tajna_url_na_tabulku",
        name: "analysis-manager",
        component: AnalysisManager
    },
    {
        path: "/analysis/:hash",
        props: true,
        name: "analysis-overview",
        component: AnalysisOverview
    },
    {
        path: "/teaser/:hash",
        props: true,
        name: "teaser",
        component: Teaser
    },
    {
        path: "/lite/:hash",
        props: true,
        name: "lite",
        component: Lite
    },
    {
        path: "/full/:hash",
        props: true,
        name: "full",
        component: Full
    },
    {
        path: "/:version/:hash/suppliers",
        props: true,
        name: "suppliers",
        component: Suppliers
    },
    {
        path: "/:version/:hash/tenders",
        props: true,
        name: "tenders",
        component: Tenders
    },
    {
        path: "/:version/:hash/contracts",
        props: true,
        name: "contracts",
        component: Contracts
    },
    {
        path: "/:version/:hash/network",
        props: true,
        name: "network",
        component: Network
    },
    {
        path: "/:version/:hash/supplier/:slug",
        props: true,
        name: "supplier-detail",
        component: SupplierDetail
    },
    {
        path: "/:version/:hash/tender/:slug",
        props: true,
        name: "tender-detail",
        component: TenderDetail
    },
    {
        path: "/:version/:hash/contract/:slug",
        props: true,
        name: "contract-detail",
        component: ContractDetail
    },
    {
        path: "/:version/:hash/icontract/:slug",
        props: true,
        name: "icontract-detail",
        component: ContractDetail
    },
    {
        path: "/:catchAll(.*)",
        name: "not-found",
        component: NotFound
    }
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes
});

export default router;
